import React from "react"
import styled from "styled-components"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import AccentTitleDivider from "../../../components/shared/accent-title-divider/accent-title-divider"
import { Grid, Block, Spacer } from "../../atoms/layout-primitives"
import ContentBlock from "../../molecules/content-block"
import withAnimation from "../../util/withAnimation"
import Button from "../../atoms/button"

const Span = styled.span`
  display: inline-block;
`

const AnimatedSpan = withAnimation(Span)

const Highlight = styled(AnimatedSpan)`
  display: inline;
  color: var(--burnt-orange);

  letter-spacing: 0.08em;
  text-transform: uppercase;
`

const Bold = styled(AnimatedSpan)`
  display: inline;
  font-weight: 500;
`

export default function CommunityStandards() {
  const query = useStaticQuery(graphql`
    query {
      communityStandardCheck: file(
        relativePath: {
          eq: "1_SOLUTIONS/Imdf/1_Desktop/community_standard_check.png"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1920, quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      digitalDirectoryImage: file(
        relativePath: { eq: "1_SOLUTIONS/Imdf/1_Desktop/intro_image.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1920, quality: 95) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      mappingCmsImage: file(
        relativePath: { eq: "1_SOLUTIONS/Imdf/1_Desktop/indoor_mapping.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1920, quality: 95) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      consistantExperienceImages: allFile(
        filter: {
          relativeDirectory: { eq: "1_SOLUTIONS/Imdf/1_Desktop/gallery" }
        }
        sort: { fields: base }
      ) {
        edges {
          node {
            id
            base
            childImageSharp {
              fluid(maxWidth: 1920, quality: 100) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
    }
  `)

  return (
    <>
      <Grid>
        <Block
          row={{ sm: "1 / -1", lg: 2 }}
          col={{ sm: "1 / -1", md: "5 / 9", lg: "6 / 8" }}
          variants={[
            { marginTop: 30, justifyContent: "center" },
            { marginTop: 30, marginBottom: 0 },
            { marginBottom: 36 },
          ]}
        >
          <Img
            fluid={query.communityStandardCheck.childImageSharp.fluid}
            imgStyle={{ objectFit: "contain" }}
            alt="A laptop displaying Mappedin Developer Tools"
          />
        </Block>
        <Spacer height={{ sm: "48px", md: "24px", lg: "96px" }} />
        <Block col={{ sm: "1 / -1", md: "2 / -2", lg: "3 / -3" }}>
          <ContentBlock.H2
            title="IMDF Approved as the 
            New Community Standard "
            description={
              <AnimatedSpan>
                <Bold>
                  The Open Geospatial Consortium (OGC) approved IMDF as a new
                  Community Standard. <br></br>
                  <br></br>
                </Bold>
                "Indoor Mapping Data Format provides a mobile-friendly, compact,
                human-readable, temporally aware, highly extensible data model
                for any indoor space, providing a basis for orientation,
                navigation, and discovery."<br></br>
                <br></br>
                <Bold>
                  <Highlight>The Open Geospatial Consortium</Highlight>
                </Bold>
              </AnimatedSpan>
            }
            variants={{ md: { textAlign: "center" } }}
          />
          <Button.Link
            to="https://www.ogc.org/pressroom/pressreleases/4415"
            target="_blank"
            variants={{
              sm: { margin: "32px auto 0" },
              lg: { margin: "48px auto 0" },
            }}
          >
            Read the Release
          </Button.Link>
        </Block>
      </Grid>
      <Spacer height={{ sm: "48px", lg: "96px" }} />
      <AccentTitleDivider variants={[{ textAlign: "left" }]}>
        An Improved IMDF Workflow
      </AccentTitleDivider>
    </>
  )
}
